/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosConfig";
import Select from 'react-select';
import { calculateAge } from "../../utils/utils";
import { useNavigate, useParams } from 'react-router-dom';
import { cleanRut, formatRut } from "../../utils/rut";

const findOptionLabel = (options = [], value) => {
    const found = options.find((option) => String(option.value) === String(value));
    return found?.label || "";
};

const EditarAuxiliar = ({ idAuxiliar, onSuccess }) => {
    const params = useParams();
    const id = idAuxiliar || params.id;
    const [especialidades, setEspecialidades] = useState([]);
    const [turnos, setTurnos] = useState([]);
    const [selectedTurnos, setSelectedTurnos] = useState([]);
    const [categorizaciones, setCategorizaciones] = useState([]);
    const [clasificaciones, setClasificaciones] = useState([]);
    const [anticipoOptions, setAnticipoOptions] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [datosContacto, setDatosContacto] = useState({});
    const [otrosDatos, setOtrosDatos] = useState({});
    const [categoriaOriginal, setCategoriaOriginal] = useState({
        id: "",
        label: "",
        observacion: "",
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axiosInstance.get("/params/especialidades");
                const turnosResponse = await axiosInstance.get("/params/turnos");
                const categorizacionesResponse = await axiosInstance.get("/params/categorias");
                const clasificacionesResponse = await axiosInstance.get("/params/clasificaciones");
                const comunaResponse = await axiosInstance.get("/params/comunas");
                setTurnos(turnosResponse.data.turnos);
                setEspecialidades(response.data.especialidades);
                setCategorizaciones(categorizacionesResponse.data.categorias.map(categorias => ({
                    value: categorias.id,
                    label: categorias.codigo
                })));
                setClasificaciones(clasificacionesResponse.data.clasificaciones.map(clasificacion => ({
                    value: clasificacion.id,
                    label: clasificacion.nombre
                })));
                setComunas(comunaResponse.data.comunas.map(comuna => ({
                    value: comuna.id,
                    label: comuna.nombre
                })));
                setAnticipoOptions([{value: 0, label: 'No'},
                                    {value: 1, label: 'Si'}]);
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);

    const navigate = useNavigate();

    const [datosPersonales, setDatosPersonales] = useState({
        rut: "",
        nombre: "",
        segundoApellido: "",
        primerApellido: "",
        direccion: "",
        comuna: "",
        numeroCelular: "",
        estatura: "",
        nacionalidad: "",
        estadoCivil: "",
        hijosMenores: "",
        fechaNacimiento: "",
        presentacionPersonal: "",
        observacionesPersonales: "",
        curriculum: null,
        sexo: 0,
        estadoCivil: 0,
    });

    const [datosProfesionales, setDatosProfesionales] = useState({
        categoria: "",
        clasificaciones: "",
        titulo: "",
        institucion: "",
        especialidades: [],
        experienciaDomicilio: "",
        experienciaGeriatrica: "",
        anticipo: "",
        evaluacion: "",
        recomendadaPor: "",
        obsCategoria: "",
    });

    const [disponibilidadTurnos, setDisponibilidadTurnos] = useState({
        observacionesTurnos: "",
    });
    useEffect(() => {
        const fetchAuxiliar = async () => {
            try {
                gdAlertify.showLoader();
                const response = await axiosInstance.get(`/auxiliar/busqueda`, {
                    params: { idAuxiliar: id }
                });
        
                const data = response.data.data;
        
                if (!data || data.length === 0) {
                    gdAlertify.hideLoader();
                    gdAlertify.notiError("No se encontró el auxiliar.");
                    return;
                }
        
                const aux = data[0];
        
                setDatosPersonales({
                    id: aux.id,
                    rut: aux.rut,
                    nombre: aux.nombre,
                    primerApellido: aux.apellidoPaterno,
                    segundoApellido: aux.apellidoMaterno,
                    nombreAuxiliar: aux.nombreAuxiliar,
                    sexo: aux.sexo,
                    estatura: aux.estatura,
                    edad: aux.edad,
                    fechaNacimiento: aux.fechaNacimiento,
                    estadoCivil: aux.estadoCivil,
                    hijosMenores: aux.hijosMenores18,
                    nacionalidad: aux.nacionalidad,
                    fonoFijo: aux.fonoFijo,
                    numeroCelular: aux.celular,
                    direccion: aux.direccion,
                    comuna: aux.comunaID,
                    des_comuna: aux.des_comuna,
                    email: aux.email
                });
        
                setDatosProfesionales({
                    categoria: aux.categoriaID,
                    clasificacion: aux.clasificacionID,
                    evaluacion: aux.evaluacion,
                    titulo: aux.titulo,
                    institucion: aux.institucion,
                    educacionMedia: aux.educacionMedia,
                    presentacionPersonal: aux.presentacionPersonal,
                    observacionesPersonales: aux.observaciones,
                    recomendadaPor: aux.recomendadaPor,
                    contrato: aux.contrato,
                    fechaIngreso: aux.fechaIngreso,
                    anticipo: aux.anticipo,
                    especialidades: aux.especialidades ? aux.especialidades.map(e => parseInt(e.especialidadID || e)) : [],
                    obsTurnos: aux.obsTurnos,
                    obsCategoria: aux.obs_categoria || "",
                });

                setCategoriaOriginal({
                    id: aux.categoriaID || "",
                    label: findOptionLabel(categorizaciones, aux.categoriaID),
                    observacion: aux.obs_categoria || "",
                });

                if (aux.turnos && aux.turnos.length > 0) {
                    const idsTurnos = aux.turnos.map(t => parseInt(t.turnoID));
                    setSelectedTurnos(idsTurnos);
                } else {
                    setSelectedTurnos([]);
                }
                setDatosContacto({
                    fonoFijo: aux.fonoFijo,
                    numeroCelular: aux.celular,
                    direccion: aux.direccion,
                    comunaID: aux.comunaID,
                    des_comuna: aux.des_comuna,
                    email: aux.email
                });

                setOtrosDatos({
                    des_categoria: aux.des_categoria
                });
                
            } catch (error) {
                gdAlertify.notiError("Error al cargar datos del auxiliar");
            } finally {
                gdAlertify.hideLoader();
            }
        };
        if (id) {
            fetchAuxiliar();
        }
    }, [id, categorizaciones]);

    const handleTurnoChange = (e) => {
        const id = parseInt(e.target.value); // Usar value en lugar de id
        const checked = e.target.checked;
        if (checked) {
            setSelectedTurnos([...selectedTurnos, id]);
        } else {
            setSelectedTurnos(selectedTurnos.filter((item) => item !== id));
        }
    };

    const handleInputChange = (e, section, setSection) => {
        var { name, value, type, checked } = e.target;

        if (name === "rut") {
            value = formatRut(cleanRut(value));
        }
        if (type === "checkbox") {
            setSection((prev) => ({
                ...prev,
                [name]: checked,
            }));
        } else {
            setSection((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleEspecialidadesChange = (e) => {
        const value = parseInt(e.target.value);
        const checked = e.target.checked;
        setDatosProfesionales((prev) => ({
            ...prev,
            especialidades: checked
                ? [...prev.especialidades, value]
                : prev.especialidades.filter((esp) => esp !== value),
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // VALIDACIÓN
        if (!datosPersonales.comuna) {
            gdAlertify.alert("Debe seleccionar una comuna");
            return;
        }

        if (!datosProfesionales.categoria) {
            gdAlertify.alert("Debe seleccionar una Categoría");
            return;
        }

        if (!datosProfesionales.clasificacion) {
            gdAlertify.alert("Debe seleccionar una Clasificación");
            return;
        }

        gdAlertify.confirm({
            title: 'Confirmar auxiliar',
            message: '¿Está seguro de editar el auxiliar?',
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const categoriaAnteriorId = categoriaOriginal.id;
                    const categoriaNuevaId = datosProfesionales.categoria;
                    const categoriaCambio = Boolean(id) && String(categoriaAnteriorId || "") !== String(categoriaNuevaId || "");

                    const response = await axiosInstance.post("/auxiliar/guardar", {
                        datosPersonales,
                        datosProfesionales,
                        disponibilidadTurnos,
                        selectedTurnos,
                        auditoriaCategoria: categoriaCambio ? {
                            auxiliarID: id,
                            categoriaAnteriorID: categoriaAnteriorId || null,
                            categoriaAnterior: categoriaOriginal.label || findOptionLabel(categorizaciones, categoriaAnteriorId),
                            categoriaNuevaID: categoriaNuevaId || null,
                            categoriaNueva: findOptionLabel(categorizaciones, categoriaNuevaId),
                            observacion: (datosProfesionales.obsCategoria || "").trim(),
                        } : null,
                    });

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        if (onSuccess) {
                            onSuccess();
                        } else {
                            navigate(-1);
                        }
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    const groupedEspecialidades = especialidades.reduce((acc, esp) => {
        const { idCategoria, nombreCategoria, idEspecialidad, nombreEspecialidad } = esp;
        // Si la categoría no existe en el acumulador, la creamos
        if (!acc[idCategoria]) {
            acc[idCategoria] = {
                nombreCategoria,
                especialidades: [],
            };
        }

        // Agregar la especialidad al grupo correspondiente
        acc[idCategoria].especialidades.push({ idEspecialidad, nombreEspecialidad });

        return acc;
    }, {});

    const handleComuna = (selectedOption) => {
        setDatosPersonales({ ...datosPersonales, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleCategorizacion = (selectedOption) => {
        setDatosProfesionales({ ...datosProfesionales, categoria: selectedOption ? selectedOption.value : "" });
    };

    const handleClasificacion = (selectedOption) => {
        setDatosProfesionales({ ...datosProfesionales, clasificacion: selectedOption ? selectedOption.value : "" });
    };

    const handleAnticipo = (selectedOption) => {
        setDatosProfesionales({ ...datosProfesionales, anticipo: selectedOption ? selectedOption.value : "" });
    };

    return (
        <form onSubmit={handleSubmit} className={idAuxiliar ? "mt-2" : "container mt-5"}>
            <div className="card shadow">
                <div className="card-body">
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Personales</legend>
                        <div className="row">
                            {[
                                { name: "rut", label: "RUT o Pasaporte" },
                                { name: "nombre", label: "Nombre" },
                                { name: "primerApellido", label: "Primer Apellido" },
                                { name: "segundoApellido", label: "Segundo Apellido" },
                                { name: "numeroCelular", label: "Número de Celular" },
                                { name: "estatura", label: "Estatura (cm)" },
                                { name: "nacionalidad", label: "Nacionalidad" },
                                { name: "hijosMenores", label: "N° Hijos Menores de 18" },
                                { name: "fechaNacimiento", label: "Fecha de Nacimiento", type: "date" },
                                { name: "direccion", label: "Dirección" },
                            ].map((field) => (
                                <div className="col-md-6 mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>
                                    <input
                                        type={field.type || "text"}
                                        className="form-control"
                                        name={field.name}
                                        value={datosPersonales[field.name]}
                                        onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}
                                    />
                                </div>
                            ))}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Comuna</label>
                                <Select
                                    options={comunas}
                                    value={comunas.find(option => option.label === datosPersonales.comuna)}
                                    onChange={handleComuna}
                                    placeholder="Seleccione una comuna"
                                    isClearable
                                />
                            </div>
                            <p><strong>Edad:</strong> {calculateAge(datosPersonales.fechaNacimiento)}</p>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Genero</label>
                                <select 
                                    className="form-control" 
                                    id="sexo" 
                                    name="sexo" 
                                    value={datosPersonales.sexo}
                                    onChange={(e) => handleInputChange(e, 'datosPersonales', setDatosPersonales)}
                                    >
                                    <option value="" disabled>Seleccione un género</option>
                                    <option value="1">Masculino</option>
                                    <option value="2">Femenino</option>
                                    <option value="3">Otro</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Estado Civil</label>
                                <select className="form-control" id="estadoCivil" name="estadoCivil" 
                                value={datosPersonales.estadoCivil}
                                onChange={(e) => handleInputChange(e, datosPersonales, setDatosPersonales)}>
                                    <option value="" disabled selected>Seleccione un estado civil</option>
                                    <option value="1">Soltero</option>
                                    <option value="2">Casado</option>
                                    <option value="3">Divorciado</option>
                                    <option value="4">Viudo</option>
                                    <option value="5">Concubinato</option>
                                    <option value="6">Otro</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Presentación Personal</label>
                                <textarea
                                    className="form-control"
                                    name="presentacionPersonal"
                                    rows="2"
                                    value={datosProfesionales.presentacionPersonal}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones iniciales</label>
                                <textarea
                                    className="form-control"
                                    name="observacionesPersonales"
                                    rows="2"
                                    value={datosProfesionales.observacionesPersonales}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Datos Profesionales</legend>
                        <div className="row">
                            {[
                                { name: "titulo", label: "Título o Diploma" },
                                { name: "institucion", label: "Institución" },
                            ].map((field) => (
                                <div className="col-md-6 mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={field.name}
                                        value={datosProfesionales[field.name]}
                                        onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                    />
                                </div>
                            ))}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Especialidades</label>
                                <div className="row">
                                    {Object.keys(groupedEspecialidades).map((categoriaId) => {
                                        const categoria = groupedEspecialidades[categoriaId];
                                        return (
                                            <fieldset className="border p-3 mb-3" key={categoriaId}>
                                                <div className="col-md-12">
                                                    <h5>{categoria.nombreCategoria}</h5>
                                                    <div className="row">
                                                        {categoria.especialidades.map((esp) => (
                                                            <div className="col-md-2" key={esp.idEspecialidad}>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        value={esp.idEspecialidad}
                                                                        onChange={handleEspecialidadesChange}
                                                                        checked={
                                                                            Array.isArray(datosProfesionales.especialidades) 
                                                                                ? datosProfesionales.especialidades.includes(parseInt(esp.idEspecialidad))
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label className="form-check-label">{esp.nombreEspecialidad}</label>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </fieldset>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="col-md-12 mb-3">
                                <label className="form-label">Categoria</label>
                                <Select
                                    options={categorizaciones}
                                    value={categorizaciones.find(option => String(option.value) === String(datosProfesionales.categoria))}
                                    onChange={handleCategorizacion}
                                    placeholder="Seleccione una categoria"
                                    isClearable
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Clasificación</label>
                                <Select
                                    options={clasificaciones}
                                    value={clasificaciones.find(option => String(option.value) === String(datosProfesionales.clasificacion))}
                                    onChange={handleClasificacion}
                                    placeholder="Seleccione una clasificacion"
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones Categoria</label>
                                <textarea
                                    className="form-control"
                                    name="obsCategoria"
                                    rows="2"
                                    value={datosProfesionales.obsCategoria || ""}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Anticipo</label>
                                <Select
                                    options={anticipoOptions}
                                    value={anticipoOptions.find(option => option.label == datosProfesionales.anticipo) }
                                    onChange={handleAnticipo}
                                    placeholder="Seleccione Anticipo"
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Evaluacion</label>
                                <textarea
                                    className="form-control"
                                    name="evaluacion"
                                    rows="2"
                                    value={datosProfesionales.evaluacion}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Experiencia en domicilio</label>
                                <textarea
                                    className="form-control"
                                    name="experienciaDomicilio"
                                    rows="2"
                                    value={datosProfesionales.experienciaDomicilio}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Experiencia Institución Geriatrica</label>
                                <textarea
                                    className="form-control"
                                    name="experienciaGeriatica"
                                    rows="2"
                                    value={datosProfesionales.experienciaGeriatica}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Recomendada por:</label>
                                <textarea
                                    className="form-control"
                                    name="recomendadaPor"
                                    rows="2"
                                    value={datosProfesionales.recomendadaPor}
                                    onChange={(e) => handleInputChange(e, datosProfesionales, setDatosProfesionales)}
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Disponibilidad de Turnos</legend>
                        <div className="row">
                            {turnos.map((turno) => (
                                <div key={turno.id} className="col-md-3 mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`turno-${turno.id}`}
                                        value={turno.id}
                                        checked={selectedTurnos.includes(parseInt(turno.id))}
                                        onChange={handleTurnoChange}
                                    />
                                    <label className="form-check-label" htmlFor={`turno-${turno.id}`}>
                                        {turno.nombre}
                                    </label>
                                </div>
                            ))}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Observaciones Turnos</label>
                                <textarea
                                    className="form-control"
                                    name="observacionesTurnos"
                                    rows="2"
                                    value={disponibilidadTurnos.observacionesTurnos}
                                    onChange={(e) =>
                                        handleInputChange(e, disponibilidadTurnos, setDisponibilidadTurnos)
                                    }
                                ></textarea>
                            </div>
                        </div>
                        <input
                            type={"hidden"}
                            className="form-control"
                            name={id}
                            value={datosPersonales[id]}
                            onChange={handleInputChange}
                            required
                        />
                    </fieldset>

                    <div className="d-grid">
                        <button className="btn btn-primary" type="submit">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default EditarAuxiliar;
